import {ImageContainer, IsAFMark, IsNewMark, IsSTMark} from "./styles";

export default function ImageFormatter({ value, isNew, isST, isAF}: { value?: string, isNew: boolean , isST: boolean, isAF: boolean}) {
  const noLogoUrl = "http://lk.seafoodexporussia.com/upload/no-logo.png"

    return (
    <ImageContainer>
      {isNew && <IsNewMark />}
      {isST && <IsSTMark />}
      {isAF && <IsAFMark />}
      <img src={value || noLogoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }}  />
    </ImageContainer>
  )
}
